import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"margin-bottom":"20px","text-align":"right"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("选择相对方")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("删除")

import { PropType, reactive, ref, unref, onMounted, watch } from 'vue';
import { ElMessage, ElMessageBox, ElForm } from 'element-plus';

/* 辅助函数 */
import { propTypes } from '@/utils/propTypes'

/* 自定义组件 */
import { GbDialog } from '@/components/GbDialog/Index';
import { GbTables } from '@/components/GbTables'
import Selecteds from '@/views/consignee/components/Selected.vue'

/* Apis*/
import { CpDetailApi } from '@/apis/counterpart/counterpart.api';

/* types */
import { TableColumn } from '@/components/GbTables/GbTablesTypes'
import { CounterparDetail } from '@/apis/counterpart/counterpart.type';
import { findIndex } from '../../../utils/index';
import { GetPartType } from '../../../helpers/statusHelpers';


export default /*#__PURE__*/_defineComponent({
  props: {
    isPreviews: propTypes.bool.def(false),
    dataList: {
        type: Object as PropType<CounterparDetail[]>,
        default: () => ([])
    },
},
  emits: ['update'],
  setup(__props, { emit: emits }) {

const props = __props



const consigneelist = ref<CounterparDetail[]>([]);
const cpSelectRef = ref<InstanceType<typeof Selecteds>>()

const tabColumns = reactive<TableColumn[]>([
    { field: 'no', label: '编号', columnWidth: "120" },
    { field: 'name', label: '名称', columnWidth: "180" },
    { field: 'code', label: '统一信用代码', columnWidth: "180" },
    { field: 'contract', label: '联系人', columnWidth: "80" },
    { field: 'contract_num', label: '联系人电话', columnWidth: "120" },
    { field: 'address', label: '地址', align: "left" },
])



/* 选择相对方(乙方) */
const onSelectConsignee = (rowId: string) => {

    CpDetailApi(rowId).then(res => {

        if (!res.succeeded) {

            ElMessage.error(`获取相对方资料失败！原因可能是：${res.errors}`)

        } else {

            const resData = res.data
            const itemIndex = findIndex(consigneelist.value, (t: any) => { return t.id == resData.id })

            if (itemIndex >= 0) {

                ElMessage.error(`已添加名为：${resData.name}的相对方。`)

            }
            else {

                resData.address = `${resData.country}，${resData.province}${resData.address}`

                resData.category_name = GetPartType(resData.part_type_id).text

                consigneelist.value.push(resData)

                const partyBList = consigneelist.value.map((item: CounterparDetail) => {
                    return item.name;
                });

                emits('update', partyBList.join(','))
            }

        }

    }).finally(() => { unref(cpSelectRef)?.pubMethods.closeCpDialog() })
}

/* 删除选中相对方 */
const deleteConsignee = (item: any) => {
    const rowIndex = findIndex(consigneelist.value, (t: any) => { return t.id == item.id })
    if (rowIndex < 0) return;

    ElMessageBox.confirm("是否删除选中的数据？", "提示", { lockScroll: false, confirmButtonText: "确定", cancelButtonText: "取消", type: 'warning' })
        .then(() => {
            consigneelist.value.splice(rowIndex, 1)
        })
}



/* 点击选择相对方 */
const onSelectBtnClick = () => {

    const ref = unref(cpSelectRef)

    if (!ref) return

    ref.pubMethods.showCpDialog()

}

watch(
    () => props.dataList, (list: Array<CounterparDetail>) => {
        consigneelist.value = list;
    },
    { deep: true, immediate: true }
)

watch(
    () => props.isPreviews,
    (isPreview) => {
        if (!isPreview) {
            tabColumns.push({ field: 'action', width: '180px', label: "操作", fixed: 'right', align: 'center' })
        }
    },
    { deep: true, immediate: true }
)


// defineExpose({ })


return (_ctx: any,_cache: any) => {
  const _component_ElButton = _resolveComponent("ElButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!props.isPreviews)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ElButton, {
            type: "primary",
            onClick: onSelectBtnClick
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(GbTables), {
      ref: "gbTablesRef",
      columns: _unref(tabColumns),
      data: consigneelist.value,
      showPaged: false
    }, {
      action: _withCtx(({ row }) => [
        (!props.isPreviews)
          ? (_openBlock(), _createBlock(_component_ElButton, {
              key: 0,
              type: "danger",
              link: "",
              onClick: ($event: any) => (deleteConsignee(row))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data"]),
    _createVNode(Selecteds, {
      ref_key: "cpSelectRef",
      ref: cpSelectRef,
      onOnSelect: onSelectConsignee
    }, null, 512)
  ], 64))
}
}

})